
const AxelLogo = ({ circleStroke, size }) => (
  <svg
    width={`${size ?? 30}`}
    height={`${size ?? 30}`}
    viewBox="-1 -1 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_320_46)">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="url(#paint0_linear_320_46)"
        strokeWidth={`${circleStroke ?? "3"}`}
      />

      <circle cx="12" cy="12" r="9.5" fill="white" />

      <path
        d="M13.0376 8.95508C13.4342 8.95508 13.8021 9.15997 14.0065 9.49476L15.1638 11.3913C15.2315 11.5021 15.2338 11.6404 15.1692 11.753C15.1045 11.8657 14.983 11.9356 14.8516 11.9356H7.19609C7.06467 11.9356 6.94318 11.8657 6.87849 11.753C6.81391 11.6404 6.8162 11.5021 6.88387 11.3913L8.04118 9.49415C8.24554 9.1594 8.61351 8.95508 9.01009 8.95508H13.0376ZM9.01009 9.67325C8.86933 9.67325 8.73871 9.74593 8.66616 9.86475L7.84082 11.2168H14.2069L13.3815 9.86475C13.309 9.74593 13.1783 9.67329 13.0376 9.67325H9.01009Z"
        fill="#2660E6"
      />
      <path
        d="M4.53467 12.3303V11.5762C4.53467 11.3779 4.69816 11.2168 4.8995 11.2168H16.7655C18.0239 11.2168 19.0442 12.222 19.0442 13.4615V14.2157C19.0442 14.414 18.8807 14.575 18.6794 14.575H6.81336C5.55503 14.575 4.53467 13.5699 4.53467 12.3303ZM5.26434 12.3303C5.26434 13.1732 5.95772 13.8563 6.81336 13.8563H18.3146V13.4615C18.3146 12.6186 17.6212 11.9356 16.7655 11.9356H5.26434V12.3303Z"
        fill="#2660E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4927 14.2157C9.4927 14.8404 8.97852 15.3468 8.34448 15.3468C7.71019 15.3468 7.19604 14.8404 7.19604 14.2157C7.19604 13.5909 7.71019 13.0845 8.34448 13.0845C8.97852 13.0845 9.4927 13.5909 9.4927 14.2157Z"
        fill="white"
      />
      <path
        d="M9.12795 14.2157C9.12795 13.7892 8.77715 13.4439 8.34446 13.4439C7.91152 13.4439 7.56097 13.7893 7.56097 14.2157C7.56097 14.642 7.91152 14.9874 8.34446 14.9875C8.77715 14.9875 9.12795 14.6421 9.12795 14.2157ZM9.85763 14.2157C9.85763 15.0388 9.17984 15.7062 8.34446 15.7062C7.50894 15.7062 6.8313 15.0388 6.8313 14.2157C6.8313 13.3925 7.50894 12.7251 8.34446 12.7251C9.17984 12.7251 9.85763 13.3925 9.85763 14.2157Z"
        fill="#2660E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3828 14.2157C16.3828 14.8404 15.8687 15.3468 15.2346 15.3468C14.6004 15.3468 14.0862 14.8404 14.0862 14.2157C14.0862 13.5909 14.6004 13.0845 15.2346 13.0845C15.8687 13.0845 16.3828 13.5909 16.3828 14.2157Z"
        fill="white"
      />
      <path
        d="M16.0178 14.2157C16.0178 13.7892 15.667 13.4439 15.2343 13.4439C14.8014 13.4439 14.4508 13.7893 14.4508 14.2157C14.4508 14.642 14.8014 14.9874 15.2343 14.9875C15.667 14.9875 16.0178 14.6421 16.0178 14.2157ZM16.7475 14.2157C16.7475 15.0388 16.0697 15.7062 15.2343 15.7062C14.3988 15.7062 13.7212 15.0388 13.7212 14.2157C13.7212 13.3925 14.3988 12.7251 15.2343 12.7251C16.0697 12.7251 16.7475 13.3925 16.7475 14.2157Z"
        fill="#2660E6"
      />
    </g>

    <path
      d="M20.2666 1.20206C20.6289 0.633979 21.5105 0.674033 21.7989 1.32291C22.369 2.60556 23.3944 3.63098 24.6771 4.20105C25.369 4.50861 25.369 5.49139 24.6771 5.79895C23.3944 6.36902 22.369 7.39444 21.7989 8.67709C21.4914 9.36904 20.5086 9.36904 20.201 8.67709L20.0892 8.43955C19.5021 7.26789 18.5254 6.33339 17.3229 5.79895C16.674 5.51054 16.6339 4.62891 17.202 4.26665L17.3229 4.20105L17.5604 4.08919C18.7321 3.50209 19.6666 2.52541 20.201 1.32291L20.2666 1.20206Z"
      fill="url(#paint1_linear_320_46)"
      stroke="white"
      strokeLinejoin="round"
    />

    <defs>
      <linearGradient
        id="paint0_linear_320_46"
        x1="0"
        y1="12"
        x2="24"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00D9FF" />
        <stop offset="0.384615" stopColor="#2660E6" />
        <stop offset="0.644231" stopColor="#2660E6" />
        <stop offset="1" stopColor="#00D9FF" />
      </linearGradient>

      <linearGradient
        id="paint1_linear_320_46"
        x1="18.8786"
        y1="7.12132"
        x2="23.1213"
        y2="2.87868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00D9FF" />
        <stop offset="0.384615" stopColor="#2660E6" />
        <stop offset="0.644231" stopColor="#2660E6" />
        <stop offset="1" stopColor="#00D9FF" />
      </linearGradient>

      <clipPath id="clip0_320_46">
        <rect x="-2" y="-2" width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const AxelStar = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 14 14"
      style={{
        position: "absolute",
        right: "0px",
        top: "-6px",
      }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.52033 1.32475C6.04441 0.50347 7.31965 0.562016 7.73694 1.50015C8.5145 3.24966 9.91381 4.64896 11.6633 5.42652C12.6638 5.87153 12.6638 7.29204 11.6633 7.73705C9.91381 8.51461 8.5145 9.91392 7.73694 11.6634C7.29193 12.6639 5.87142 12.6639 5.42641 11.6634L5.27312 11.3389C4.47232 9.74093 3.1401 8.46597 1.50004 7.73705C0.561906 7.31976 0.503362 6.04452 1.32464 5.52044L1.50004 5.42652L1.82459 5.27323C3.42253 4.47243 4.6975 3.14021 5.42641 1.50015L5.52033 1.32475Z"
        fill="url(#paint0_linear_415_108)"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_415_108"
          x1="3.66486"
          y1="9.4986"
          x2="9.49849"
          y2="3.66497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D9FF" />
          <stop offset="0.384615" stopColor="#2660E6" />
          <stop offset="0.644231" stopColor="#2660E6" />
          <stop offset="1" stopColor="#00D9FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const AxelLogoCarOnly = () => {
  return (
    <svg
      width="40"
      height="15"
      viewBox="0 0 15 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.50291 0C8.89949 0 9.26746 0.204895 9.47182 0.539677L10.6291 2.43618C10.6968 2.54704 10.6991 2.68528 10.6345 2.79794C10.5698 2.91059 10.4483 2.98055 10.3169 2.98055H2.66142C2.53 2.98055 2.40851 2.91059 2.34382 2.79794C2.27924 2.68528 2.28153 2.54704 2.3492 2.43618L3.50651 0.539069C3.71088 0.204322 4.07884 0 4.47542 0H8.50291ZM4.47542 0.718173C4.33466 0.718173 4.20404 0.790854 4.13149 0.909671L3.30615 2.26177H9.67219L8.8468 0.909671C8.77429 0.790854 8.64364 0.718209 8.50291 0.718173H4.47542Z"
        fill="#2660E6"
      />
      <path
        d="M0 3.37525V2.62111C0 2.42281 0.163491 2.26172 0.364836 2.26172H12.2309C13.4892 2.26172 14.5096 3.26689 14.5096 4.50644V5.26057C14.5096 5.45888 14.3461 5.61993 14.1447 5.61993H2.27869C1.02036 5.61993 0 4.61479 0 3.37525ZM0.729673 3.37525C0.729673 4.21815 1.42305 4.90118 2.27869 4.90118H13.7799V4.50644C13.7799 3.66353 13.0865 2.9805 12.2309 2.9805H0.729673V3.37525Z"
        fill="#2660E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95803 5.26058C4.95803 5.88534 4.44385 6.39177 3.80981 6.39177C3.17552 6.39177 2.66138 5.88534 2.66138 5.26058C2.66138 4.6358 3.17552 4.12939 3.80981 4.12939C4.44385 4.12939 4.95803 4.6358 4.95803 5.26058Z"
        fill="white"
      />
      <path
        d="M4.59329 5.2606C4.59329 4.83415 4.24249 4.4888 3.80979 4.4888C3.37685 4.48884 3.0263 4.83422 3.0263 5.2606C3.0263 5.68694 3.37685 6.03232 3.80979 6.0324C4.24249 6.0324 4.59329 5.68705 4.59329 5.2606ZM5.32296 5.2606C5.32296 6.08369 4.64518 6.75114 3.80979 6.75114C2.97427 6.75111 2.29663 6.08369 2.29663 5.2606C2.29663 4.43747 2.97427 3.77006 3.80979 3.77002C4.64518 3.77002 5.32296 4.43747 5.32296 5.2606Z"
        fill="#2660E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8482 5.26058C11.8482 5.88534 11.334 6.39177 10.6999 6.39177C10.0657 6.39177 9.55151 5.88534 9.55151 5.26058C9.55151 4.6358 10.0657 4.12939 10.6999 4.12939C11.334 4.12939 11.8482 4.6358 11.8482 5.26058Z"
        fill="white"
      />
      <path
        d="M11.4831 5.2606C11.4831 4.83415 11.1324 4.4888 10.6997 4.4888C10.2667 4.48884 9.91616 4.83422 9.91616 5.2606C9.91616 5.68694 10.2667 6.03232 10.6997 6.0324C11.1324 6.0324 11.4831 5.68705 11.4831 5.2606ZM12.2128 5.2606C12.2128 6.08369 11.5351 6.75114 10.6997 6.75114C9.86416 6.75111 9.18652 6.08369 9.18652 5.2606C9.18652 4.43747 9.86416 3.77006 10.6997 3.77002C11.5351 3.77002 12.2128 4.43747 12.2128 5.2606Z"
        fill="#2660E6"
      />
    </svg>
  );
};

const AxelLogoInPill = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="-1 -1 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_320_46)">
        <circle
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke="url(#paint0_linear_320_46)"
          strokeWidth="5"
        />

        <circle cx="12" cy="12" r="9.5" fill="white" />

        <path
          d="M13.0376 8.95508C13.4342 8.95508 13.8021 9.15997 14.0065 9.49476L15.1638 11.3913C15.2315 11.5021 15.2338 11.6404 15.1692 11.753C15.1045 11.8657 14.983 11.9356 14.8516 11.9356H7.19609C7.06467 11.9356 6.94318 11.8657 6.87849 11.753C6.81391 11.6404 6.8162 11.5021 6.88387 11.3913L8.04118 9.49415C8.24554 9.1594 8.61351 8.95508 9.01009 8.95508H13.0376ZM9.01009 9.67325C8.86933 9.67325 8.73871 9.74593 8.66616 9.86475L7.84082 11.2168H14.2069L13.3815 9.86475C13.309 9.74593 13.1783 9.67329 13.0376 9.67325H9.01009Z"
          fill="#2660E6"
        />
        <path
          d="M4.53467 12.3303V11.5762C4.53467 11.3779 4.69816 11.2168 4.8995 11.2168H16.7655C18.0239 11.2168 19.0442 12.222 19.0442 13.4615V14.2157C19.0442 14.414 18.8807 14.575 18.6794 14.575H6.81336C5.55503 14.575 4.53467 13.5699 4.53467 12.3303ZM5.26434 12.3303C5.26434 13.1732 5.95772 13.8563 6.81336 13.8563H18.3146V13.4615C18.3146 12.6186 17.6212 11.9356 16.7655 11.9356H5.26434V12.3303Z"
          fill="#2660E6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.4927 14.2157C9.4927 14.8404 8.97852 15.3468 8.34448 15.3468C7.71019 15.3468 7.19604 14.8404 7.19604 14.2157C7.19604 13.5909 7.71019 13.0845 8.34448 13.0845C8.97852 13.0845 9.4927 13.5909 9.4927 14.2157Z"
          fill="white"
        />
        <path
          d="M9.12795 14.2157C9.12795 13.7892 8.77715 13.4439 8.34446 13.4439C7.91152 13.4439 7.56097 13.7893 7.56097 14.2157C7.56097 14.642 7.91152 14.9874 8.34446 14.9875C8.77715 14.9875 9.12795 14.6421 9.12795 14.2157ZM9.85763 14.2157C9.85763 15.0388 9.17984 15.7062 8.34446 15.7062C7.50894 15.7062 6.8313 15.0388 6.8313 14.2157C6.8313 13.3925 7.50894 12.7251 8.34446 12.7251C9.17984 12.7251 9.85763 13.3925 9.85763 14.2157Z"
          fill="#2660E6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3828 14.2157C16.3828 14.8404 15.8687 15.3468 15.2346 15.3468C14.6004 15.3468 14.0862 14.8404 14.0862 14.2157C14.0862 13.5909 14.6004 13.0845 15.2346 13.0845C15.8687 13.0845 16.3828 13.5909 16.3828 14.2157Z"
          fill="white"
        />
        <path
          d="M16.0178 14.2157C16.0178 13.7892 15.667 13.4439 15.2343 13.4439C14.8014 13.4439 14.4508 13.7893 14.4508 14.2157C14.4508 14.642 14.8014 14.9874 15.2343 14.9875C15.667 14.9875 16.0178 14.6421 16.0178 14.2157ZM16.7475 14.2157C16.7475 15.0388 16.0697 15.7062 15.2343 15.7062C14.3988 15.7062 13.7212 15.0388 13.7212 14.2157C13.7212 13.3925 14.3988 12.7251 15.2343 12.7251C16.0697 12.7251 16.7475 13.3925 16.7475 14.2157Z"
          fill="#2660E6"
        />
      </g>

      <path
        d="M20.2666 1.20206C20.6289 0.633979 21.5105 0.674033 21.7989 1.32291C22.369 2.60556 23.3944 3.63098 24.6771 4.20105C25.369 4.50861 25.369 5.49139 24.6771 5.79895C23.3944 6.36902 22.369 7.39444 21.7989 8.67709C21.4914 9.36904 20.5086 9.36904 20.201 8.67709L20.0892 8.43955C19.5021 7.26789 18.5254 6.33339 17.3229 5.79895C16.674 5.51054 16.6339 4.62891 17.202 4.26665L17.3229 4.20105L17.5604 4.08919C18.7321 3.50209 19.6666 2.52541 20.201 1.32291L20.2666 1.20206Z"
        fill="url(#paint1_linear_320_46)"
        stroke="white"
        strokeLinejoin="round"
      />

      <defs>
        <linearGradient
          id="paint0_linear_320_46"
          x1="0"
          y1="12"
          x2="24"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D9FF" />
          <stop offset="0.384615" stopColor="#2660E6" />
          <stop offset="0.644231" stopColor="#2660E6" />
          <stop offset="1" stopColor="#00D9FF" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_320_46"
          x1="18.8786"
          y1="7.12132"
          x2="23.1213"
          y2="2.87868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D9FF" />
          <stop offset="0.384615" stopColor="#2660E6" />
          <stop offset="0.644231" stopColor="#2660E6" />
          <stop offset="1" stopColor="#00D9FF" />
        </linearGradient>

        <clipPath id="clip0_320_46">
          <rect x="-2" y="-2" width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { AxelLogo, AxelLogoCarOnly, AxelLogoInPill, AxelStar };
